module.exports = __webpack_public_path__ + "static/media/fly0033.128feb78.webp";